 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		4: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"0f1ac474","3":"5b74f8667f3a7f27ab8185c7fc08a7f63be63316","6":"component---src-pages-404-js","7":"component---src-pages-contact-index-js","8":"component---src-pages-day-camp-christmas-day-camp-js","9":"component---src-pages-day-camp-march-break-day-camp-js","10":"component---src-pages-day-camp-pd-pa-day-camp-js","11":"component---src-pages-events-christmas-at-the-ranch-js","12":"component---src-pages-events-easter-roundup-js","13":"component---src-pages-events-family-day-roundup-js","14":"component---src-pages-events-family-winter-activity-adventure-js","15":"component---src-pages-events-march-break-camp-for-a-weekend-js","16":"component---src-pages-events-teen-ranch-fall-gallop-a-cross-country-run-js","17":"component---src-pages-events-the-christmas-winter-festival-js","18":"component---src-pages-facilities-js","19":"component---src-pages-families-family-getaway-weekends-js","20":"component---src-pages-families-father-son-hockey-weekend-js","21":"component---src-pages-families-js","22":"component---src-pages-families-mother-daughter-equine-escape-js","23":"component---src-pages-give-index-js","24":"component---src-pages-in-memory-of-mel-stevens-js","25":"component---src-pages-index-js","26":"component---src-pages-outdoor-education-js","27":"component---src-pages-programs-hockey-and-skating-3-on-3-hockey-league-js","28":"component---src-pages-programs-hockey-and-skating-adult-hockey-skills-js","29":"component---src-pages-programs-hockey-and-skating-afternoon-summer-skills-clinics-js","30":"component---src-pages-programs-hockey-and-skating-goalie-clinic-js","31":"component---src-pages-programs-hockey-and-skating-ice-rental-js","32":"component---src-pages-programs-hockey-and-skating-index-js","33":"component---src-pages-programs-hockey-and-skating-learn-to-skate-js","34":"component---src-pages-programs-hockey-and-skating-mens-hockey-league-js","35":"component---src-pages-programs-hockey-and-skating-private-lessons-js","36":"component---src-pages-programs-hockey-and-skating-public-skating-js","37":"component---src-pages-programs-hockey-and-skating-skills-and-skating-development-js","38":"component---src-pages-programs-hockey-and-skating-spring-hockey-league-js","39":"component---src-pages-programs-hockey-and-skating-starskate-and-competitive-figure-skating-js","40":"component---src-pages-programs-hockey-and-skating-wranglers-hockey-js","41":"component---src-pages-programs-horses-hunter-jumper-shows-index-js","42":"component---src-pages-programs-horses-hunter-jumper-shows-show-photos-js","43":"component---src-pages-programs-horses-index-js","44":"component---src-pages-programs-horses-schooling-ring-rental-js","45":"component---src-pages-programs-horses-trail-rides-js","46":"component---src-pages-programs-index-js","47":"component---src-pages-retreats-index-js","48":"component---src-pages-staff-index-js","49":"component---src-pages-summer-camp-js","50":"component---src-pages-summer-camp-junior-day-camp-js","51":"component---src-pages-summer-camp-overnight-camp-hockey-camps-js","52":"component---src-pages-summer-camp-overnight-camp-horse-camps-js","53":"component---src-pages-summer-camp-overnight-camp-js","54":"component---src-pages-summer-camp-overnight-camp-wham-camp-js","55":"component---src-pages-summer-camp-ultimate-day-camp-hockey-camps-js","56":"component---src-pages-summer-camp-ultimate-day-camp-horse-camps-js","57":"component---src-pages-summer-camp-ultimate-day-camp-js","58":"component---src-pages-summer-camp-ultimate-day-camp-wham-camp-js","59":"component---src-pages-teen-ranch-statement-of-faith-js","60":"component---src-pages-terms-and-conditions-js"}[chunkId]||chunkId) + "-" + {"0":"60315f64d8c49defa917","1":"29147cbc04bbc833f6a0","2":"f52c8a944af07ee5cce8","3":"0fdb89d859c22b09fe27","6":"17fa762cd453e0ba0279","7":"557d21496fb76d71943a","8":"58a74c843898d6a353a3","9":"00ba63ad1cf108e73bc5","10":"9842a3be6f05aed1ace2","11":"1777354975db1c914445","12":"34fe08fff7987d1ab8e8","13":"767bde1987f417dd7a9a","14":"01246b336ef9fd01539d","15":"38d3b3a266765520b909","16":"a4153b7b3025d79b3682","17":"b7640b507663caac2ce1","18":"df01ec8f6048d3454f80","19":"4b8155ee0020efbdc6c2","20":"1941bddff0eaa919a196","21":"cb2274bbc8fea7488c26","22":"acc619459eeffaf714c1","23":"614706dc7d82715c4cc5","24":"c9fbc4386e0b3975b232","25":"a3129bc8cd8bdd182901","26":"37e9dbfd330123921aaf","27":"ac7f4870e64a2d45c869","28":"d496074e026b8f875f51","29":"e1bb96c233bb5dfce155","30":"909666197e9b35edfad4","31":"81fd1f216deea2037741","32":"cd3e820c8eea6539a361","33":"7a2150263ae6c18bffe5","34":"bff6275fea2705e880c3","35":"64443266baca08d4bc11","36":"905188dc817e77726ec5","37":"24683467652637362755","38":"baa98dc28ae4167afe58","39":"a9a8c742fd25367ac24b","40":"392e646af2ad330d1be8","41":"9c3e91691f03019eaa9f","42":"3b9784ff5322e9a38137","43":"06f43e2bf790488608e5","44":"3403548f5fcd3f169a85","45":"636f1d90741bcee6ca1e","46":"5dad660b27058d2ea9ec","47":"9da854d74be2013d9de6","48":"f20a9e7a5420252d0a35","49":"43295133c572d72afaa6","50":"81e9372029b8c0d1f9c0","51":"53d1cd7b1e757d7a292b","52":"15832910bf2e620a2c37","53":"7f5141d4a3ea7ba9c6dd","54":"7b6200b53fc37f1527f3","55":"2ee5a04ba984c17de4ee","56":"903351a3438f05c9acf2","57":"2e02ac8e8a3fd0893219","58":"72a3db05248bbbb3cb6d","59":"a1f77e6f130052e76c82","60":"61d2fc1fdc781b3b334b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"0f1ac474","3":"5b74f8667f3a7f27ab8185c7fc08a7f63be63316","6":"component---src-pages-404-js","7":"component---src-pages-contact-index-js","8":"component---src-pages-day-camp-christmas-day-camp-js","9":"component---src-pages-day-camp-march-break-day-camp-js","10":"component---src-pages-day-camp-pd-pa-day-camp-js","11":"component---src-pages-events-christmas-at-the-ranch-js","12":"component---src-pages-events-easter-roundup-js","13":"component---src-pages-events-family-day-roundup-js","14":"component---src-pages-events-family-winter-activity-adventure-js","15":"component---src-pages-events-march-break-camp-for-a-weekend-js","16":"component---src-pages-events-teen-ranch-fall-gallop-a-cross-country-run-js","17":"component---src-pages-events-the-christmas-winter-festival-js","18":"component---src-pages-facilities-js","19":"component---src-pages-families-family-getaway-weekends-js","20":"component---src-pages-families-father-son-hockey-weekend-js","21":"component---src-pages-families-js","22":"component---src-pages-families-mother-daughter-equine-escape-js","23":"component---src-pages-give-index-js","24":"component---src-pages-in-memory-of-mel-stevens-js","25":"component---src-pages-index-js","26":"component---src-pages-outdoor-education-js","27":"component---src-pages-programs-hockey-and-skating-3-on-3-hockey-league-js","28":"component---src-pages-programs-hockey-and-skating-adult-hockey-skills-js","29":"component---src-pages-programs-hockey-and-skating-afternoon-summer-skills-clinics-js","30":"component---src-pages-programs-hockey-and-skating-goalie-clinic-js","31":"component---src-pages-programs-hockey-and-skating-ice-rental-js","32":"component---src-pages-programs-hockey-and-skating-index-js","33":"component---src-pages-programs-hockey-and-skating-learn-to-skate-js","34":"component---src-pages-programs-hockey-and-skating-mens-hockey-league-js","35":"component---src-pages-programs-hockey-and-skating-private-lessons-js","36":"component---src-pages-programs-hockey-and-skating-public-skating-js","37":"component---src-pages-programs-hockey-and-skating-skills-and-skating-development-js","38":"component---src-pages-programs-hockey-and-skating-spring-hockey-league-js","39":"component---src-pages-programs-hockey-and-skating-starskate-and-competitive-figure-skating-js","40":"component---src-pages-programs-hockey-and-skating-wranglers-hockey-js","41":"component---src-pages-programs-horses-hunter-jumper-shows-index-js","42":"component---src-pages-programs-horses-hunter-jumper-shows-show-photos-js","43":"component---src-pages-programs-horses-index-js","44":"component---src-pages-programs-horses-schooling-ring-rental-js","45":"component---src-pages-programs-horses-trail-rides-js","46":"component---src-pages-programs-index-js","47":"component---src-pages-retreats-index-js","48":"component---src-pages-staff-index-js","49":"component---src-pages-summer-camp-js","50":"component---src-pages-summer-camp-junior-day-camp-js","51":"component---src-pages-summer-camp-overnight-camp-hockey-camps-js","52":"component---src-pages-summer-camp-overnight-camp-horse-camps-js","53":"component---src-pages-summer-camp-overnight-camp-js","54":"component---src-pages-summer-camp-overnight-camp-wham-camp-js","55":"component---src-pages-summer-camp-ultimate-day-camp-hockey-camps-js","56":"component---src-pages-summer-camp-ultimate-day-camp-horse-camps-js","57":"component---src-pages-summer-camp-ultimate-day-camp-js","58":"component---src-pages-summer-camp-ultimate-day-camp-wham-camp-js","59":"component---src-pages-teen-ranch-statement-of-faith-js","60":"component---src-pages-terms-and-conditions-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"77b6846d73c4497a0f4c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
